import { render } from "./modal_etatdespaiement.vue?vue&type=template&id=2b115556&scoped=true"
import script from "./modal_etatdespaiement.vue?vue&type=script&lang=js"
export * from "./modal_etatdespaiement.vue?vue&type=script&lang=js"

import "./modal_etatdespaiement.vue?vue&type=style&index=0&id=2b115556&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b115556"]])

export default __exports__